import * as React from "react";
import { TriangleAlert } from "lucide-react";
import { cn } from "../utils/cn";
import { OrgAvatar } from "./OrgAvatar";
import { Heading, Text } from "../primitives/typography";

export interface EngagementDip {
    id: string;
    name: string;
    subtitle?: string;
    fallback: string;
    change: number;
}

export interface EngagementDipsCardProps extends React.HTMLAttributes<HTMLDivElement> {
    dips: EngagementDip[];
}

const EngagementDipsCard = React.forwardRef<HTMLDivElement, EngagementDipsCardProps>(
    ({ className, dips, ...props }, ref) => (
        <div ref={ref} className={cn("border-border bg-card flex flex-col rounded-2xl border", className)} {...props}>
            {/* Header */}
            <div className="px-5 pt-5 pb-4">
                <div className="flex items-center gap-2">
                    <TriangleAlert className="text-warning h-4 w-4 shrink-0" />
                    <Heading level={6} className="font-semibold">
                        Engagement dips
                    </Heading>
                </div>
                <Text size="sm" muted>
                    Orgs with notable activity drop
                </Text>
            </div>

            {/* Dip rows */}
            <div className="divide-border flex flex-col divide-y">
                {dips.map((dip) => (
                    <div key={dip.id} className="flex items-center gap-3 px-5 py-4">
                        <OrgAvatar id={dip.id} fallback={dip.fallback} size="sm" />

                        <div className="min-w-0 flex-1">
                            <p className="font-display text-foreground truncate text-sm font-semibold">{dip.name}</p>
                            {dip.subtitle && <p className="text-muted-foreground text-xs">{dip.subtitle}</p>}
                        </div>

                        <span className="text-destructive shrink-0 text-sm font-semibold">
                            {dip.change > 0 ? "+" : ""}
                            {dip.change}%
                        </span>
                    </div>
                ))}
            </div>
        </div>
    ),
);
EngagementDipsCard.displayName = "EngagementDipsCard";

export { EngagementDipsCard };
